import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const GalleryImportIcon = forwardRef<SVGSVGElement, IconProps>(function GalleryImportIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M15.75 17.5C17.683 17.5 19.25 15.933 19.25 14C19.25 12.067 17.683 10.5 15.75 10.5C13.817 10.5 12.25 12.067 12.25 14C12.25 15.933 13.817 17.5 15.75 17.5Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 3.5H15.75C7 3.5 3.5 7 3.5 15.75V26.25C3.5 35 7 38.5 15.75 38.5H26.25C35 38.5 38.5 35 38.5 26.25V17.5"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 3.5V14L35 10.5"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 14L28 10.5"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.67285 33.163L13.3004 27.3705C14.6829 26.443 16.6779 26.548 17.9204 27.6155L18.4979 28.123C19.8629 29.2955 22.0679 29.2955 23.4329 28.123L30.7129 21.8755C32.0779 20.703 34.2829 20.703 35.6479 21.8755L38.5004 24.3255"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgStyled>
  );
});
